import React, { useEffect, useState } from "react";
import { HERO_LIST } from "../../../utils/defaults";
import BlueTag from "../ui/BlueTag";

const Hero = ({ value }) => {
  const [heroList, setHeroList] = useState(HERO_LIST[value]);
  useEffect(() => {
    setHeroList(HERO_LIST[value]);
  }, []);

  return (
    <div className="aspect-[1440/386] w-full relative min-h-[280px] 2xl:max-h-[600px]">
      <div className="absolute bg-black opacity-70 h-full w-full top-0 left-0 z-10"></div>
      <img
        src={heroList.image}
        alt="bg layer content"
        sizes="100vw"
        className={`absolute top-0 left-0 h-full w-full object-cover object-center z-0 opacity-90`}
      />
      <div className="max-w-[1200px] mx-auto px-5 text-center flex flex-col justify-center items-center h-full py-5 relative z-30">
        <BlueTag center variant="white" className="2xl:!text-2xl">
          {heroList.tag}
        </BlueTag>
        <h1 className="text-white !leading-120 font-bold text-3xl sm:text-4xl md:text-5xl lg:text-[52px] mt-2 sm:mt-3 lg:mt-4 2xl:text-[64px]">
          {heroList.title}
        </h1>
      </div>
    </div>
  );
};

export default Hero;
